import { Injectable } from '@angular/core';
import { ApiVersion } from '@core/constants';
import { IAddressGroup } from '@core/models/address-group';
import { BaseResponse } from '@core/models/base-response';
import { BaseService } from '@core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressGroupService extends BaseService {
  readonly addressGroupsUrl: string = 'customers/address-groups';

  getAddressGroups(): Observable<BaseResponse<IAddressGroup[]>> {
    return this.get(this.addressGroupsUrl, {
      apiVersion: ApiVersion.V1,
    });
  }

  getGroup(id: string | number): Observable<BaseResponse<IAddressGroup>> {
    return this.get(`${this.addressGroupsUrl}/${id}`, {
      apiVersion: ApiVersion.V1,
    });
  }

  addAddressGroup(body: {
    groupName: string;
    groupDescription?: string;
    addressMembers?: number[];
  }): Observable<BaseResponse<IAddressGroup>> {
    return this.post(this.addressGroupsUrl, body, {
      apiVersion: ApiVersion.V1,
    });
  }

  editAddressGroup(
    addressGroupId: number,
    body: {
      groupName: string;
      groupDescription?: string;
    }
  ): Observable<BaseResponse<IAddressGroup>> {
    return this.put(`${this.addressGroupsUrl}/${addressGroupId}`, body, {
      apiVersion: ApiVersion.V1,
    });
  }

  removeAddressesFromAddressGroup(
    addressGroupId: number,
    addressIdList: number[]
  ): Observable<BaseResponse> {
    return this.put(
      `${this.addressGroupsUrl}/${addressGroupId}/members/remove`,
      { addressMembers: addressIdList },
      {
        apiVersion: ApiVersion.V1,
      }
    );
  }

  deleteGroup(id: any) {
    return this.patch<BaseResponse<any>>(
      `${this.addressGroupsUrl}/${id}/status/PASSIVE`,
      {},
      {
        apiVersion: ApiVersion.V1,
      }
    );
  }

  addToGroup(addressGroups: number[], addressMembers: number[]) {
    return this.put<BaseResponse<any>>(
      `${this.addressGroupsUrl}/members`,
      {
        addressGroups,
        addressMembers,
      },
      {
        apiVersion: ApiVersion.V1,
      }
    );
  }
}
